import { Alert, type AlertProps, Collapse } from "@mui/material";

export interface IAlertCollapseProps extends AlertProps {
  open: boolean;
}

export const AlertCollapse = ({ open, children, ...alertProps }: IAlertCollapseProps) => {
  return (
    <Collapse orientation="vertical" in={open} timeout={{ enter: 300, exit: 300 }}>
      <Alert {...alertProps}>{children}</Alert>
    </Collapse>
  );
};
